import React from 'react';
import { motion } from 'framer-motion';
import GuestSelector from '../components/GuestSelector';

interface StepGuestsProps {
  value: number | null;
  maxGuests?: number;
  onSelect: (n: number) => void;
  onAutoAdvance: () => void;
}

const StepGuests: React.FC<StepGuestsProps> = ({ value, maxGuests = 10, onSelect, onAutoAdvance }) => {
  const handleSelect = (n: number) => {
    onSelect(n);
    setTimeout(() => onAutoAdvance(), 300);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.25 }}
      className="flex flex-col items-center justify-center min-h-[300px]"
    >
      <GuestSelector value={value} maxGuests={maxGuests} onChange={handleSelect} />
    </motion.div>
  );
};

export default StepGuests;
